/**
 * Is high resolution device
 * @const
 */
export const IS_HIDPI = window.devicePixelRatio > 1;



// WEBPACK FOOTER //
// ./app/scripts/utils/constants.ts